export default function TrainingAdministrationDirectiveController(
  $q,
  $scope,

  loaderService,
  eduDataService

  // ,trainingAdminMedia
) {
  const vm = this;

  vm.appIsLoaded = false;
  vm.loaderService = loaderService;
  vm.topics = [];
  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();
    _initEventListeners();
    _refreshMediaList().then(dfdActivate.resolve);

    dfdActivate.promise.then(() => {
      vm.appIsLoaded = true;
    });
    return dfdActivate.promise;
  }

  // //// Initialize Module //////
  function _initEventListeners() {
    $scope.$on('refreshEduMedia', _refreshMediaList);
  }
  function _refreshMediaList() {
    const dfdRefresh = $q.defer();
    eduDataService.getTopics().then((topicsData) => {
      vm.topics = topicsData.data.result;
      dfdRefresh.resolve();
    });
    return dfdRefresh.promise;
  }
}


TrainingAdministrationDirectiveController.$inject = [
  '$q',
  '$scope',

  'loaderService',
  'eduDataService'

  // ,'trainingAdminMedia'
];
